import ReactMarkdown from "react-markdown";

import { ReleaseNotesItem, ReleaseNotesIssueType } from "../utils/types";
import { capitalizeFirstLetter } from "../utils/helpers";

interface IssueLabelProps {
    issueType: ReleaseNotesIssueType;
}

const IssueLabel = ({ issueType }: IssueLabelProps) => {
    let bgColor;
    if (issueType === ReleaseNotesIssueType.Fixed) {
        bgColor = "border-[#FECDCA] bg-[#FEF3F2] text-[#B42318]";
    } else if (issueType === ReleaseNotesIssueType.Improved) {
        bgColor = "border-[#FEDF89] bg-[#FFFAEB] text-[#B54708]";
    } else {
        bgColor = "border-max-200 bg-max-50 text-max-900";
    }

    return (
        <div
            className={`px-1.5 py-0.5 text-xs font-medium rounded-md border flex items-center justify-center ${bgColor}`}
        >
            {capitalizeFirstLetter(issueType)}
        </div>
    );
};

interface Props {
    items: ReleaseNotesItem[];
}

const ReleaseNotesBody = ({ items }: Props) => {
    return (
        <div className="flex flex-col gap-2 bg-white">
            {items.map((item, index) => (
                <div key={index} className="grid grid-cols-[70px_1fr] gap-2 rounded-md">
                    <div>
                        <IssueLabel issueType={item.issue_type} />
                    </div>
                    <div className="text-sm prose text-gray-900 [&_strong]:text-gray-900 [&_blockquote]:text-gray-600 [&_h1]:text-gray-900 [&_h2]:text-gray-900 [&_h3]:text-gray-900 [&_h4]:text-gray-900 [&_h5]:text-gray-900 [&_h6]:text-gray-900">
                        <ReactMarkdown
                            components={{
                                a: ({ node, children, ...props }) => (
                                    <a className="text-max-600" {...props} target="_blank" rel="noopener noreferrer">
                                        {children}
                                    </a>
                                ),
                            }}
                        >
                            {item.description}
                        </ReactMarkdown>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ReleaseNotesBody;
